import React from 'react'


export const Auth = () => {

    return (
            <div className='auth-block'>
                <div className='auth-form'>
                  <div className='form-login'>
                    <span>Login</span>
                    <input 
                    id='email'
                    type='email'
                    name='email'
                    placeholder="Email"
                    // onChange={changeHandler}
                    required
                    />
                  </div>
                  <div className='form-passw'>
                    <span>Password</span>
                    <input 
                    id='password'
                    type='password'
                    name='password'
                    placeholder='Password'
                    // onChange={changeHandler}
                    required
                    />
                  </div>
                  <div className='auth-btn'>
                    <button 
                    type='button'
                    // onClick={loginHandler}
                    // disabled={loading}
                    >LOGIN</button>              
                  </div>
                </div>
            </div>
    )
}

export default Auth
